// Generated by tools/design-tokens from design/figma. Do not edit.

import type { DrawingPart } from './drawings';

/** A part of a chain drawing: as the turtle's, or an ellipse stroked inside its box. */
export type ChainDrawingPart =
  | DrawingPart
  | {
      ring: true;
      x: number;
      y: number;
      w: number;
      h: number;
      stroke: string;
      width: number;
    };

/** A chain drawing's box, in canvas pixels. */
export const CHAIN_DRAWING_SIZE = { width: 480, height: 320 } as const;

/** Sample / Chain drawing, by its Drawing variant. */
export const chainDrawings = {
  'Turtle on skateboard': [
    { d: 'M5 101C5 -27 225 -27 225 101H5Z', x: 105, y: 105, stroke: '#3e8e5e', width: 10 },
    { d: 'M5.085 5C3.085 45 37.085 47 37.085 7', x: 134.46, y: 202.51, stroke: '#3e8e5e', width: 10 },
    { d: 'M5.085 5C3.085 45 37.085 47 37.085 7', x: 272.46, y: 202.51, stroke: '#3e8e5e', width: 10 },
    { d: 'M35.001 5.001L5.001 21.001', x: 75, y: 195, stroke: '#3e8e5e', width: 10 },
    { d: 'M5 5H21', x: 325, y: 187, stroke: '#3e8e5e', width: 10 },
    { d: 'M5 35C5 18.4 18.4 5 35 5C51.6 5 65 18.4 65 35C65 51.6 51.6 65 35 65C18.4 65 5 51.6 5 35Z', x: 339, y: 147, stroke: '#3e8e5e', width: 10 },
    { d: 'M5 21L39 5L73 21V61L39 77L5 61V21Z', x: 181, y: 115, stroke: '#8a5a3b', width: 10 },
    { d: 'M37.037 16L21.037 4M105.037 56L139.037 82M37.037 56L3.037 82M105.037 16L121.037 4', x: 148.5, y: 120, stroke: '#8a5a3b', width: 10 },
    { d: 'M2 4.001C8 10.001 16 8.001 18 2.001', x: 382, y: 191.81, stroke: '#282b25', width: 4 },
    { ellipse: true, x: 377, y: 167, w: 10, h: 10, fill: 'var(--zumpo-ink)' },
    { d: 'M5 5.001C13.001 17.001 23.001 21.001 39.001 21.001H239C255 21.001 265 17.001 273 5.001', x: 91, y: 231, stroke: '#8a5a3b', width: 10 },
    { ring: true, x: 150, y: 262, w: 24, h: 24, stroke: 'var(--zumpo-brush-graphite)', width: 8 },
    { ring: true, x: 286, y: 262, w: 24, h: 24, stroke: 'var(--zumpo-brush-graphite)', width: 8 },
    { d: 'M3 3H53', x: 27, y: 147, stroke: '#5b9bd5', width: 6 },
    { d: 'M3 3H57', x: 17, y: 183, stroke: '#5b9bd5', width: 6 },
    { d: 'M3 3H49', x: 31, y: 219, stroke: '#5b9bd5', width: 6 },
  ],
  'Burger on skates': [
    { d: 'M5 62C5 -14 205 -14 205 62H5Z', x: 135, y: 84, stroke: '#f2994a', width: 10 },
    { d: 'M2.5 6.501L12.501 2.501', x: 193.5, y: 95.5, stroke: '#8a5a3b', width: 5 },
    { d: 'M2.5 2.501L12.501 6.501', x: 273.5, y: 95.5, stroke: '#8a5a3b', width: 5 },
    { d: 'M2.5 2.5H10.5', x: 235.5, y: 83.5, stroke: '#8a5a3b', width: 5 },
    { ellipse: true, x: 204, y: 116, w: 10, h: 10, fill: 'var(--zumpo-brush-ink)' },
    { ellipse: true, x: 266, y: 116, w: 10, h: 10, fill: 'var(--zumpo-brush-ink)' },
    { d: 'M2 2C10 10 26 10 34 2', x: 220, y: 128, stroke: '#282b25', width: 4 },
    { d: 'M5 9.041C21 23.042 33 -4.959 51 9.041C67 23.042 79 -4.959 97 9.041C113 23.042 125 -4.959 143 9.041C159 23.042 171 -4.959 189 9.041C203 19.042 213 13.042 221 7.041', x: 127, y: 150.655, stroke: '#a8c93a', width: 10 },
    { d: 'M18.5 5H206.5C224.5 5 224.5 29 206.5 29H18.5C0.5 29 0.5 5 18.5 5Z', x: 127.5, y: 171, stroke: '#8a5a3b', width: 10 },
    { d: 'M5 5H205C205 23 187 31 167 31H43C23 31 5 23 5 5Z', x: 135, y: 207, stroke: '#f2994a', width: 10 },
    { d: 'M4 4H80', x: 146, y: 248, stroke: '#d64532', width: 8 },
    { d: 'M4 4H80', x: 250, y: 248, stroke: '#d64532', width: 8 },
    { ring: true, x: 152, y: 264, w: 20, h: 20, stroke: 'var(--zumpo-brush-ink)', width: 7 },
    { ring: true, x: 204, y: 264, w: 20, h: 20, stroke: 'var(--zumpo-brush-ink)', width: 7 },
    { ring: true, x: 256, y: 264, w: 20, h: 20, stroke: 'var(--zumpo-brush-ink)', width: 7 },
    { ring: true, x: 308, y: 264, w: 20, h: 20, stroke: 'var(--zumpo-brush-ink)', width: 7 },
    { d: 'M3 3H55', x: 37, y: 127, stroke: '#5b9bd5', width: 6 },
    { d: 'M3 3H61', x: 25, y: 167, stroke: '#5b9bd5', width: 6 },
    { d: 'M3 3H53', x: 39, y: 207, stroke: '#5b9bd5', width: 6 },
  ],
} as const satisfies Record<string, readonly ChainDrawingPart[]>;

export type ChainDrawingName = keyof typeof chainDrawings;
